import { Outlet, useRouteLoaderData } from 'react-router'
import { useBreadcrumbLd, useOrigin } from '#app/seo/hooks.ts'
import { buildOrganizationLd } from '#app/seo/structured-data.ts'
import { MarketingFooter } from './components/marketing-footer.tsx'
import { MarketingHeader } from './components/marketing-header.tsx'
import { getMarketingNav, type MarketingNav } from './nav.server.ts'

export async function loader() {
	return { nav: await getMarketingNav() }
}

/**
 * Header and footer both need the publishable-page inventory, and neither is a
 * route. Reading it from the layout's loader keeps it to one query per request
 * instead of one per component, and means a page that forgets to provide it
 * cannot render chrome that disagrees with the rest of the site.
 */
export function useMarketingNav(): MarketingNav | null {
	const data = useRouteLoaderData<typeof loader>('routes/_marketing+/_layout')
	return data?.nav ?? null
}

export default function MarketingLayout() {
	const origin = useOrigin()
	const breadcrumbLd = useBreadcrumbLd()

	return (
		<div className="flex min-h-screen flex-col">
			<script
				type="application/ld+json"
				dangerouslySetInnerHTML={{ __html: buildOrganizationLd({ origin }) }}
			/>
			{breadcrumbLd ? (
				<script
					type="application/ld+json"
					dangerouslySetInnerHTML={{ __html: breadcrumbLd }}
				/>
			) : null}
			<MarketingHeader />
			<main className="flex-1">
				<Outlet />
			</main>
			<MarketingFooter />
		</div>
	)
}
